// extracted by mini-css-extract-plugin
export var errorsContainer = "_qm-1";
export var link = "_qm-0";